import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from './core/services/toast.service';
import { ToastComponent } from './main/shared/toast/toast.component';
import { LanguageService } from './core/services/language.service';
import { Subscription } from 'rxjs';
import { RotationWarningComponent } from './main/components/rotation-warning/rotation-warning.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    RouterOutlet,
    ToastComponent,
    RotationWarningComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  toastMessage: string = '';
  toastType: 'success' | 'error' | 'warning' = 'success';
  showToast: boolean = false;

  private subscriptions: Subscription[] = [];

  constructor(
    private translate: TranslateService,
    private toastService: ToastService,
    private languageService: LanguageService,
  ) {
    this.translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.toastService.toast$.subscribe((toast) => {
        this.toastMessage = toast.message;
        this.toastType = toast.type;
        this.showToast = toast.showToast;
      }),
    );

    this.subscriptions.push(
      this.languageService.language$.subscribe((lang) => {
        if (lang) {
          this.translate.use(lang);
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  switchLanguage(lang: string) {
    this.languageService.setLanguage(lang);
  }
}
